export enum EPlanPointMode {
  POINT = 'Point',
  POLYGON = 'Polygon',
  DRAW = 'Draw',
}
